import App from "./App.vue";
import "v-calendar/dist/style.css";
import { Calendar, DatePicker } from "v-calendar";
import { createApp } from "vue";
import router from "./router/index.js";
import "vue3-easy-data-table/dist/style.css";
import Vue3EasyDataTable from "vue3-easy-data-table";
const app = createApp(App);

import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css";
import { store } from "./store";
import mitt from "mitt";
import { vuetify } from "./plugins/vuetify";

import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'
// FormKit imports
import { plugin as formKitPlugin, defaultConfig } from "@formkit/vue";
import { createMultiStepPlugin } from "@formkit/addons";
import "@formkit/themes/genesis";
import "@formkit/addons/css/multistep";
import FooterComponent from '@/components/common/FooterComponent/index.vue'
import '../node_modules/vue-toast-notification/dist/theme-default.css';
import ToastPlugin from 'vue-toast-notification';
import '@fortawesome/fontawesome-free/css/all.css';

const emitter = mitt();

app.use(vuetify);
app.use(store);

app.config.globalProperties.emitter = emitter;


app.use(ToastPlugin,{
    position: 'top-right', // Customize position
    timeout: 5000 // Customize duration
  });

// eslint-disable-next-line vue/multi-word-component-names
app.component("Calendar", Calendar);
app.component("DatePicker", DatePicker);
app.component("EasyDataTable", Vue3EasyDataTable);
app.component("VueCal", VueCal)
app.component("FooterComponent", FooterComponent)
app.use(
    formKitPlugin,
    defaultConfig({
        plugins: [createMultiStepPlugin()],
    })
);

app.use(router);

app.mount("#app");